import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';


@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.css']
})
export class RefundComponent implements OnInit {

  title="Refund Alert";
  constructor() { }

  ngOnInit() {
  }

  payment(){
    swal({
      //title: '<i>HTML</i> <u>example</u>',
      //type: 'info',
      html:
        '<select class="form-control"><option>---Status---</option><option>under process</option><option>Pending</option><option>Refund Approve</option><option>Refunded</option></select>'+
        '<textarea placeholder="Note" class="form-control" style="height:100px;margin-top:10px;"></textarea><br><br>' ,
        
        // '<label>DD Copy</label><input style="width:70%;display:inline-block;margin-left:20px;"  type="file" class="form-control">' ,
        
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        'Confirm',    
      cancelButtonText:
      'Cancel',
    })
  }
  
}



// WEBPACK FOOTER //
// ./src/app/finance/refund/refund.component.ts